import Vue from 'vue'
import { findCurrency } from 'utils/helpers/find-store'

Vue.filter('pmlFormatCurrencyById', function (value, id, decimals = 2, decPoint = ',', thousandsSep = '.', allowNegative = true) {
    var preffix = (typeof findCurrency(id) !== 'undefined') ? findCurrency(id).symbol : ''

    decimals = isNaN(decimals = Math.abs(decimals)) ? 2 : decimals
    decPoint = decPoint === undefined ? '.' : decPoint
    thousandsSep = thousandsSep === undefined ? '' : thousandsSep

    var e = false
    var s = value < 0 && e ? '-' : ''
    var i = parseInt(value = Math.abs(+value || 0).toFixed(decimals)) + ''
    var j = i.length > 3 ? i.length % 3 : 0

    return (allowNegative && value < 0 ? '-' : '') + preffix + ' ' + s + (j ? i.substr(0, j) + thousandsSep : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousandsSep) + (decimals ? decPoint + Math.abs(value - i).toFixed(decimals).slice(2) : '')
})



// WEBPACK FOOTER //
// ./src/utils/filters/format-currency-by-id.js